import { render, staticRenderFns } from "./WithdrawalModification.vue?vue&type=template&id=b70651b2&scoped=true&"
import script from "./WithdrawalModification.vue?vue&type=script&lang=ts&"
export * from "./WithdrawalModification.vue?vue&type=script&lang=ts&"
import style0 from "./WithdrawalModification.vue?vue&type=style&index=0&id=b70651b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70651b2",
  null
  
)

export default component.exports